module.exports = __webpack_public_path__ + "img/feature-desktop.fd1e6523.webp";